/** Neutral branded spinner filling whatever area it is dropped into — the Suspense fallback
 *  shown while a route's code chunk loads. */
export function ScreenLoader(): JSX.Element {
  return (
    <div className="flex h-full items-center justify-center bg-paper py-16">
      <span
        aria-label="Loading"
        role="status"
        className="h-8 w-8 animate-spin rounded-pill border-2 border-hairline border-t-primary-600"
      />
    </div>
  );
}
